import pizzaDesktop from '@/static/assets/how_it_works/Pizza_Desktop_en-US.svg';
import pizzaMobile1 from '@/static/assets/how_it_works/Pizza_Mobile_1.svg';
import pizzaMobile2 from '@/static/assets/how_it_works/Pizza_Mobile_2.svg';
import pizzaMobile3 from '@/static/assets/how_it_works/Pizza_Mobile_3.svg';
import desktopImage from '@/static/assets/how_it_works/bottom_logos.png';
import mobileImage from '@/static/assets/how_it_works/bottom_logos_mobile.png';
import type { PizzaMobileImages } from '../';

const pizzaMobile: PizzaMobileImages = [
  { image: pizzaMobile1, text: 'A <b>flat fee</b> to\nrun everything' },
  { image: pizzaMobile2, text: 'We pay claims\n<b>super fast</b>' },
  {
    image: pizzaMobile3,
    text: "If there's money leftover,\nwe <b>give it back to causes</b>",
  },
];

export const HOW_IT_WORKS_DEFAULTS = {
  title: 'How Lemonade Works',
  subtitle: `Lemonade reverses the traditional insurance model. We treat the premiums you pay as if it's your money, not ours. With Lemonade, everything becomes simple and transparent. We take a flat fee, pay claims super fast, and [give back](link) what’s left to causes you care about.*`,
  disclaimer:
    '* Subject to board discretion and the company meeting certain financial standards. This section does not apply to Life insurance.[link](link)',
  pizzaDesktop,
  pizzaMobile,
  brandsImage: { desktop: desktopImage, mobile: mobileImage },
} as const;
